/* eslint-disable max-len */
import React from 'react';

const PlusIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
    <g fillRule="evenodd">
      <g>
        <g>
          <g>
            <path
              d="M12.5 6v5.5H18v1h-5.5V18h-1v-5.5H6v-1h5.5V6h1z"
              transform="translate(-129 -269) translate(97 105) translate(23 155) rotate(-90 21 12)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default PlusIcon;
